import React from "react";
import "../../assets/css/serviciosEspecializados.css";

const ServicioEspecializadoCard = ({
  titulo,
  subtitulo,
  descripcion,
  imagen,
  className,
  icon,
}) => (
  <div
    className={`servicioEspecializadoCard ${className}`}
    style={{ backgroundImage: `url(${imagen})` }}
  >
    <div className="textoServicio">
      <h4 className="tituloEspecializado">{subtitulo}</h4>
      <h2 className="subtituloEspecializado">{titulo}</h2>
    </div>

    <div className="contenidoEspecializado">
      {icon && <img src={icon} alt={titulo} className="iconImagen" />}
    </div>

    <div className="descripcionServicio">
      <p>{descripcion}</p>
      <div className="barraAmarilla"></div>
    </div>
  </div>
);

export default ServicioEspecializadoCard;
